import React from "react";

import Message from "./Message";

import { Link, Route, Switch } from "react-router-dom";

class Privacy extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div>
        <section className="page-header-privacy">
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-12">
                <div className="breadcrumb-wrapper text-center">
                  <h2> Timesheets for Jira Docs</h2>
                  <p>
                    <a href="index.html">Home </a>/ Privacy policy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div id="blog-single">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-xs-12">
                <div className="blog-post">
                  <div className="post-thumb">
                    <img
                      src="assets/img/privacy-bg.png"
                      alt="free jira plugin timesheets calendar for jira.com"
                    />
                  </div>
                  <div style={{ color: "#42526E" }} className="post-content">
                    <h4>Introduction</h4>

                    <p>
                      TouchDown Apps is committed to preserving the privacy of
                      all visitors to this website and of clients using our
                      products and services. Please read the following privacy
                      policy to understand how we use and protect the
                      information that you provide to us. By submitting details
                      to us, you consent to the collection, use and transfer of
                      your information under the terms of this policy. Should
                      you have any specific queries after reading this policy,
                      please feel free to contact us for clarification. We must
                      collect the information fairly, that is, we must explain
                      how we will use it (see the notices on particular web
                      pages that let you know why we are requesting the
                      information) and tell you if we want to pass the
                      information on to anyone else. Unless explicitly stated
                      otherwise, we will never pass your information on to any
                      third parties and access to your information is restricted
                      to specific TouchDown staff who may only access it for
                      specific purposes. If you post or send offensive,
                      inappropriate or objectionable content anywhere on or to
                      this website or our company or otherwise engage in any
                      disruptive behaviour, we can use whatever information that
                      is available to us to stop such behaviour. This may
                      involve informing relevant third parties such as your
                      employer, school e-mail/Internet provider and law
                      enforcement agencies about the content and your behaviour.
                    </p>

                    <h4> Contacting Us</h4>

                    <p>
                      Should you wish to contact us regarding anything within
                      this document you can do so by submitting an enquiry via
                      contact in <a href="index.html">Home</a> Page.
                    </p>
                    <h4>Information that we collect from you</h4>
                    <p>
                      When you use our products or services you may be asked to
                      provide certain information about yourself, including your
                      name and contact details. We may also collect information
                      about your usage, as well as information you provide
                      during such usage. This includes using our websites,
                      products and services, as well as any correspondence or
                      communication you send.
                    </p>

                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/components/privacy.js